import * as z from 'zod';

import { DAY_OF_WEEK } from 'src/features/membershipType/types';

export type AllowedTimeFormSchemaValues = z.infer<typeof formSchema>;
export const formSchema = z.object({
    day_of_week: z.enum(DAY_OF_WEEK),
    from_time: z.string(),
    to_time: z.string(),
});

export type CustomAllowedTimeFormSchemaValues = z.infer<typeof customAllowedTimeFormSchema>;
export const customAllowedTimeFormSchema = z.object({
    day_of_week: z.array(z.enum(DAY_OF_WEEK)).min(1),
    from_time: z.string(),
    to_time: z.string(),
});
